/** Aide cockpit lancement — FR (7 étapes + vue générale). */

const stepTemplate = (number, objective, actions, expected, next) => ({
  key: `launch-cockpit-step-${number}`,
  screenLabel: `Cockpit lancement — Étape ${number}`,
  purpose: objective,
  actions,
  warning: expected,
  nextStep: next,
});

/** @type {Record<string, object>} */
export const helpTopicsLaunchCockpitFr = {
  "launch-cockpit": {
    key: "launch-cockpit",
    screenLabel: "Cockpit Lancement 1er septembre",
    purpose: "Piloter la préparation de l'ouverture officielle du 1er septembre 2026 sans outil de gestion de projet lourd.",
    actions: [
      "Lire le résumé : compte à rebours, progression, statut délai, étape active.",
      "Consulter « À faire maintenant » (3 priorités max).",
      "Ouvrir une étape de la timeline pour voir les résultats attendus et ajuster les statuts.",
      "Vérifier la checklist « Prêt pour le 1er septembre ? ».",
    ],
    warning: "Ne jamais marquer Terminé sans vérification réelle dans l'application.",
    nextStep: "Ouvrir l'étape active pour le guide détaillé (bouton Aide se met à jour).",
  },
  ...Object.fromEntries(
    [
      stepTemplate(
        1,
        "Stabiliser le cœur V1 : auth, comptes, dojos, instructeurs, membres sur PostgreSQL.",
        [
          "Valider chaque module R0 dans le navigateur (5174).",
          "Marquer À valider tant que phase1 n'est pas branché.",
          "Ne pas commencer parcours parent tant que le cœur n'est pas stable.",
        ],
        "Auth, instructeurs et membres Terminé ou À valider avec preuve.",
        "Étape 2 — parcours membre / parent.",
      ),
      stepTemplate(
        2,
        "Parcours membre et parent complet (connexion, profil, infos élève, horaire).",
        [
          "Tester connexion parent et élève (hors démo si possible).",
          "Lister les écrans encore en localStorage.",
          "Inscrire les blocages dans le cockpit, pas de refonte silencieuse.",
        ],
        "Parent et élève peuvent accomplir le parcours minimal sans données fictives obligatoires.",
        "Étape 3 — administration dojo.",
      ),
      stepTemplate(
        3,
        "Administration dojo : membres, parents, groupes, horaire, présences.",
        [
          "Confirmer membres R0 en production de dev.",
          "Décider du périmètre V1 pour groupes et horaire.",
          "Mettre à jour « On attend de… » pour les dépendances client.",
        ],
        "Hanshi et Sensei peuvent gérer leur périmètre sans zones mortes.",
        "Étape 4 — tests réels.",
      ),
      stepTemplate(
        4,
        "Tests réels avec parcours complets desktop et mobile.",
        [
          "Exécuter npm test + validation navigateur 5174.",
          "Documenter écarts dans le cockpit (statut Bloqué si nécessaire).",
          "Vérifier persistance après refresh.",
        ],
        "Tous les parcours critiques testés et statuts à jour.",
        "Étape 5 — correctifs bloquants (gel V1 actif).",
      ),
      stepTemplate(
        5,
        "Correctifs bloquants seulement — gel des nouvelles fonctionnalités V1.",
        [
          "Refuser les nouveautés non critiques.",
          "Traiter uniquement ce qui empêche l'usage réel.",
          "Mettre à jour la checklist de lancement.",
        ],
        "Aucun blocant ouvert ; liens morts résolus ou masqués.",
        "Étape 6 — production finale.",
      ),
      stepTemplate(
        6,
        "Production finale : déploiement, seeds, validation prod.",
        [
          "Déployer frontend + backend.",
          "Exécuter seeds Mongo/PostgreSQL si applicable.",
          "Valider health et parcours Hanshi en prod.",
        ],
        "Production validée avec semver et checks automatisés.",
        "Étape 7 — ouverture officielle.",
      ),
      stepTemplate(
        7,
        "Ouverture officielle 1er septembre 2026.",
        [
          "Confirmer checklist 100 % critiques.",
          "Communiquer go/no-go à l'administration.",
          "Surveiller support jour J.",
        ],
        "Message « KARATÉ EST PRÊT À OUVRIR » affiché.",
        "Phase 2 — idées post-lancement dans le cockpit.",
      ),
    ].map((t) => [t.key, t]),
  ),
};
